import React, { Fragment } from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import styles from './index.css';
import Loadable from 'react-loadable';
import LazyLoad from '@ifeng/ui_pc_lazyLoad';
import errorBoundary from '@ifeng/errorBoundary';
import { Survey } from 'ThreeTerminal_mobile_dynamic';
import Text from './text';
import Pic from './pic';
import Goods from './goods';
import Video from './video';
import Slides from './slides';
import WbShort from './wbShort';

const EmptyBox = () => <div style={{ width: '100%', height: 1 }} />;
// const LoadaMyVideo = Loadable({
//     loader: () => import('./video'),
//     loading() {
//         return <div />;
//     },
// });

// const LoadSlides = Loadable({
//     loader: () => import('./slides'),
//     loading() {
//         return <div />;
//     },
// });

const LoadAudio = Loadable({
    loader: () => import('./audio'),
    loading() {
        return <div />;
    },
});

const LoadHouseBuild = Loadable({
    loader: () => import('./houseBuild'),
    loading() {
        return <div />;
    },
});

const LoadHouseSource = Loadable({
    loader: () => import('./houseSource'),
    loading() {
        return <div />;
    },
});

// const LoadHouseRegion = Loadable({
//     loader: () => import('./houseRegion'),
//     loading() {
//         return <div />;
//     },
// });

const LoadHouseActivity = Loadable({
    loader: () => import('./houseActivity'),
    loading() {
        return <div />;
    },
});

const LoadHouseSurvey = Loadable({
    loader: () => import('./houseSurvey'),
    loading() {
        return <div />;
    },
});

// const LoadWbShort = Loadable({
//     loader: () => import('./wbShort'),
//     loading() {
//         return <div />;
//     },
// });

const LoadShortRelate = Loadable({
    loader: () => import('./shortRelate'),
    loading() {
        return <div />;
    },
});

let enableVideosPlugin = true;
let enableAudioPlugin = true;
let enableSlidesPlugin = true;
let enableSurveyPlugin = true;
let enableHouseBuildPlugin = true;
let enableHouseSourcePlugin = true;
let enableHouseRegionPlugin = true;
let enableHouseActivityPlugin = true;
let enableWbShortPlugin = true;
let enableShortRelatePlugin = true;

class ArticleContent extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        imagesInContent: PropTypes.array,
        thumbnails: PropTypes.object,
        pluginData: PropTypes.object,
        pageInfo: PropTypes.object,
        isBig: PropTypes.bool,
        pageType: PropTypes.string,
        base62Id: PropTypes.string,
        wxLaunch: PropTypes.object,
        _id: PropTypes.string,
    };

    state = {
        galleryShow: false,
        galleryCurrent: 0,
    };

    getVideosPlugin = () => {
        const { content, pluginData, pageInfo } = this.props;

        if (content.currentPage === 0 && enableVideosPlugin && pluginData.videosPluginData) {
            pluginData.videosPluginData.map((item, index) => (
                <Video key={index} videoConfig={item} pageInfo={pageInfo} />
                // <LazyLoad key={index} placeholder={EmptyBox}>
                //     <LoadaMyVideo videoConfig={item} pageInfo={pageInfo} />
                // </LazyLoad>
            ));
        } else {
            return null;
        }
    };

    getAudioPlugin = () => {
        const { content, pluginData, pageInfo } = this.props;

        if (content.currentPage === 0 && enableAudioPlugin && pluginData.audiosPluginData) {
            pluginData.videosPluginData.map((item, index) => (
                <LazyLoad key={index} placeholder={EmptyBox}>
                    <LoadAudio audioConfig={item} pageInfo={pageInfo} />
                </LazyLoad>
            ));
        } else {
            return null;
        }
    };

    getSlidesPlugin = () => {
        const { content, pluginData } = this.props;

        if (content.currentPage === 0 && enableSlidesPlugin && pluginData.slidesPluginData) {
            pluginData.slidesPluginData.map((item, index) => (
                <Slides key={index} limit={10} attachmentId={item.attachmentId} />
                // <LazyLoad key={index} placeholder={EmptyBox}>
                //     <LoadSlides limit={10} attachmentId={item.attachmentId} />
                // </LazyLoad>
            ));
        } else {
            return null;
        }
    };

    getWbShortPlugin = wbImages => {
        const { content } = this.props;

        if (wbImages.length > 0 && content.currentPage === 0) {
            return <WbShort content={wbImages} handleGalleryOpen={this.handleGalleryOpen} />;
        } else {
            return null;
        }
    };

    getShortRelatePlugin = data => {
        if (data.title) {
            return <LoadShortRelate content={data} />;
        } else {
            return null;
        }
    };

    getSurveyPlugin = () => {
        const { content, pluginData, pageInfo } = this.props;
        let isShowCallup = true;

        if (pageInfo && pageInfo.isShowCallup === false) {
            isShowCallup = false;
        }

        if (content.currentPage === 0 && enableSurveyPlugin && pluginData.surveyPluginData) {
            return (
                <NoSSR>
                    <Survey
                        isShowCallup={isShowCallup}
                        surveyId={pluginData.surveyPluginData.attachmentId}
                        pageInfo={pageInfo}
                    />
                </NoSSR>
            );
        } else {
            return null;
        }
    };

    getHouseBuildPlugin = () => {
        const { content, pluginData } = this.props;

        if (content.currentPage === 0 && enableHouseBuildPlugin && pluginData.houseBuildPluginData) {
            return <LoadHouseBuild content={pluginData.houseBuildPluginData} />;
        } else {
            return null;
        }
    };

    getHouseSourcePlugin = () => {
        const { content, pluginData } = this.props;

        if (content.currentPage === 0 && enableHouseSourcePlugin && pluginData.houseSourcePluginData) {
            return <LoadHouseSource content={pluginData.houseSourcePluginData} />;
        } else {
            return null;
        }
    };

    // getHouseRegionPlugin = () => {
    //     const { content, pluginData } = this.props;

    //     if (content.currentPage === 0 && enableHouseRegionPlugin && pluginData.houseRegionPluginData) {
    //         return <LoadHouseRegion content={pluginData.houseRegionPluginData} />;
    //     } else {
    //         return null;
    //     }
    // };

    getHouseActivityPlugin = () => {
        const { content, pluginData } = this.props;

        if (content.currentPage === 0 && enableHouseActivityPlugin && pluginData.houseActivityPluginData) {
            return <LoadHouseActivity content={pluginData.houseActivityPluginData} />;
        } else {
            return null;
        }
    };

    getHouseSurveyPlugin = () => {
        const { pluginData } = this.props;

        if (pluginData.houseSurveyPluginData) {
            return <LoadHouseSurvey content={pluginData.houseSurveyPluginData} />;
        } else {
            return null;
        }
    };

    getcontent = (type, data, index, pageType, shortData, wbImages, totalNum) => {
        const { isBig, pageInfo, imagesInContent, base62Id, thumbnails, wxLaunch, _id, pluginData } = this.props;

        if (type === 'text') {
            let textData = pageType === 'short' ? shortData : data;

            textData =
                (textData &&
                    textData.replace(/<p>_ueditor_page_break_tag_ <\/p>|<p>_ueditor_page_break_tag_<\/p>/gi, '')) ||
                '';

            return (
                <Fragment key={index}>
                    <Text
                        content={textData}
                        isBig={isBig}
                        pageType={pageType}
                        imagesInContent={imagesInContent}
                        thumbnails={thumbnails}
                        pageInfo={pageInfo}
                        base62Id={base62Id}
                        _id={_id}
                        handleGalleryOpen={this.handleGalleryOpen}
                        wxLaunch={wxLaunch}
                    />
                    {wbImages && pageType === 'short' && totalNum - 1 === index && this.getWbShortPlugin(wbImages)}
                </Fragment>
            );
        } else if (type === 'survey') {
            let isShowCallup = true;

            if (pageInfo && pageInfo.isShowCallup === false) {
                isShowCallup = false;
            }

            return (
                <NoSSR key={index}>
                    <div className={styles.surveyBox}>
                        <Survey surveyId={data.attachmentId} isShowCallup={isShowCallup} pageInfo={pageInfo} />
                    </div>
                </NoSSR>
            );
        } else if (type === 'slide') {
            return (
                <Slides key={index} attachmentId={data.attachmentId} />
                // <LazyLoad key={index} placeholder={EmptyBox}>
                //     <LoadSlides attachmentId={data.attachmentId} />
                // </LazyLoad>
            );
        } else if (type === 'video') {
            return (
                <Video key={index} videoConfig={data} pageInfo={pageInfo} pageType={pageType} />
                // <LazyLoad key={index} placeholder={EmptyBox}>
                //     <LoadaMyVideo videoConfig={data} pageInfo={pageInfo} pageType={pageType} />
                // </LazyLoad>
            );
        } else if (type === 'audio') {
            return (
                <LazyLoad key={index} placeholder={EmptyBox}>
                    <LoadAudio videoConfig={data} pageInfo={pageInfo} />
                </LazyLoad>
            );
        } else if (type === 'houseBuilding') {
            return (
                <LazyLoad key={index} placeholder={EmptyBox}>
                    <LoadHouseBuild key={index} houseBuildConfig={data} />
                </LazyLoad>
            );
        } else if (type === 'houseResources') {
            return (
                <LazyLoad key={index} placeholder={EmptyBox}>
                    <LoadHouseSource key={index} houseSourceConfig={data} />
                </LazyLoad>
            );
        }
        // else if (type === 'houseRegion') {
        //     return (
        //         <LazyLoad key={index}>
        //             <LoadHouseRegion houseRegionConfig={data} />
        //         </LazyLoad>
        //     );
        // }
        else if (type === 'houseActivity') {
            return (
                <LazyLoad key={index} placeholder={EmptyBox}>
                    <LoadHouseActivity houseActivityConfig={data} />
                </LazyLoad>
            );
        } else if (type === 'goods') {
            return <Goods key={index} content={data} pluginData={pluginData} />;
        }
    };

    getPageList = (limit, current) => {
        const list = [];
        const baseUrl = typeof window !== 'undefined' && window.location.href.split('/test')[0].split(`_${current}`)[0];

        for (let i = 0; i < limit; i++) {
            list.push(
                <a
                    key={i}
                    href={`${baseUrl}_${i}${
                        typeof window !== 'undefined' && window.location.href.includes('/test') ? '/test' : ''
                    }`}
                    className={i === current || (current > limit - 1 && i === limit - 1) ? styles.current : ''}>
                    {current > limit - 1 ? current - 8 + i : i + 1}
                </a>,
            );
        }

        return list;
    };

    handleGalleryOpen = index => {
        this.setState({
            galleryShow: true,
            galleryCurrent: index,
        });
    };

    handleGalleryClose = () => {
        this.setState({
            galleryShow: false,
        });
    };

    render() {
        const { galleryShow, galleryCurrent } = this.state;
        let { content, imagesInContent, pageType, thumbnails } = this.props;
        let wbImages = [];
        let shortRelate = {};

        /**
         * 当文章处于第一页时，需要判断文章数据是否有视频，轮播图，调查的内容数据和插件数据
         * 当内容数据没有时，以插件数据为主；内容数据存在时，则以内容数据为主
         */
        if (content.currentPage === 0) {
            enableVideosPlugin = true;
            enableSlidesPlugin = true;
            enableSurveyPlugin = true;
            enableAudioPlugin = true;
            enableHouseBuildPlugin = true;
            enableHouseSourcePlugin = true;
            enableHouseRegionPlugin = true;
            enableHouseActivityPlugin = true;
            enableWbShortPlugin = true;
            enableShortRelatePlugin = true;

            content.contentList.forEach(item => {
                if (item.type === 'video') {
                    enableVideosPlugin = false;
                } else if (item.type === 'slide') {
                    enableSlidesPlugin = false;
                } else if (item.type === 'survey') {
                    enableSurveyPlugin = false;
                } else if (item.type === 'audio') {
                    enableAudioPlugin = false;
                } else if (item.type === 'houseBuilding') {
                    enableHouseBuildPlugin = false;
                } else if (item.type === 'houseResources') {
                    enableHouseSourcePlugin = false;
                } else if (item.type === 'houseRegion') {
                    enableHouseRegionPlugin = false;
                } else if (item.type === 'houseRegion') {
                    enableHouseActivityPlugin = false;
                }

                if (pageType === 'short' && item.images && Array.isArray(item.images) && item.images.length > 0) {
                    enableWbShortPlugin = true;
                    wbImages = wbImages.concat(item.images);
                }

                if (item.type === 'related' && item.data && item.data.title) {
                    enableShortRelatePlugin = true;
                    shortRelate = item.data;
                }
            });
        } else {
            enableVideosPlugin = false;
            enableSlidesPlugin = false;
            enableSurveyPlugin = false;
            enableAudioPlugin = false;
            enableHouseBuildPlugin = false;
            enableHouseSourcePlugin = false;
            enableHouseRegionPlugin = false;
            enableHouseActivityPlugin = false;
            enableWbShortPlugin = false;
            enableShortRelatePlugin = false;
        }

        if (
            (!imagesInContent || imagesInContent.length === 0) &&
            thumbnails &&
            thumbnails.image &&
            thumbnails.image.length > 0
        ) {
            imagesInContent = thumbnails.image;
        }

        return (
            <div>
                {this.getAudioPlugin()}
                {this.getVideosPlugin()}
                {this.getSlidesPlugin()}

                {content.contentList.map((item, index) =>
                    this.getcontent(
                        item.type,
                        item.data,
                        index,
                        pageType,
                        item.shortData,
                        wbImages,
                        content.contentList.length,
                    ),
                )}
                {this.getSurveyPlugin()}
                {content.pageSize > 1 ? (
                    <div className={styles.page_list}>{this.getPageList(content.pageSize, content.currentPage)}</div>
                ) : (
                    ''
                )}
                {this.getShortRelatePlugin(shortRelate)}
                <NoSSR>
                    <Pic
                        content={imagesInContent}
                        galleryShow={galleryShow}
                        galleryCurrent={galleryCurrent}
                        handleGalleryClose={this.handleGalleryClose}
                    />
                    {this.getHouseSurveyPlugin()}
                </NoSSR>
            </div>
        );
    }
}

export default errorBoundary(ArticleContent);
